import React from 'react';

/**
 * Badge component for displaying notification counts
 * Shows a small pink/purple gradient circle with count 1-99+
 * Hidden when count is 0
 */
const Badge = ({ count, className = '' }) => {
  // Don't render if count is 0 or null
  if (!count || count === 0) return null;
  
  // Format count: 1-99 show exact number, 100+ show "99+"
  const displayCount = count > 99 ? '99+' : count;
  
  return (
    <span 
      className={`inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold text-white bg-gradient-to-r from-pink-500 to-purple-600 rounded-full ${className}`}
      style={{
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      {displayCount}
    </span>
  );
};

export default Badge;
